module.exports = __webpack_public_path__ + "img/icon1.d57315c9.png";